<template>
  <div class="info-region-container" v-allow="'0906'" style="width: 100%">
    <div class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <h4>系统日志</h4>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <!-- <el-form-item label="日志类型：">
            <el-select v-model="formInline.type" placeholder="请选择日志类型">
              <el-option
                v-for="item in options"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="操作人：">
            <el-input v-model="formInline.name" placeholder="请输入操作人" clearable maxlength="15"></el-input>
          </el-form-item>

          <el-form-item label="操作时间：">
            <el-date-picker style="margin-top: 4px" v-model="formInline.updateTime" type="daterange" align="right"
              unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions" @change="getDateTime" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>

          <el-form-item v-allow="'090601'">
            <el-button type="primary" @click="systemLog">查询</el-button>
            <el-button type="button" @click="resetSystemLog">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1">
          <el-table :data="tableData" align="center" :header-cell-style="{ background: '#f4f5f7' }" class="data-table"
            style="width: 100%" max-height="500">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="date" align="center" label="日志类型" show-overflow-tooltip>
              <template slot-scope="scope">
                <p>{{ scope.row.type | logtype }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="username" align="center" label="操作人"></el-table-column>
            <el-table-column prop="content" align="center" class="text_count" label="操作内容" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="content_cell">{{ scope.row.content }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" align="center" label="操作时间" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
              :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "systemLog",
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pagesize: 8,
      currentPage: 1,
      total: 0,
      begDate: "",
      endDate: "",
      formInline: {
        name: "",
        userId: "",
        type: "", //类型（0操作日志，1定时任务）
        parentId: "", //上级机构（无上级为0）
        endTime: "9999-11-11", //结束时间
        startTime: "1949-10-1", //开始时间
        updateTime: "",
      },
      options: [
        {
          type: "",
          name: "全部",
        },
        {
          type: 0,
          name: "操作日志",
        },
        {
          type: 2,
          name: "定时任务",
        },
      ],
      modelNoListData: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "管理员",
          id: 0,
        },
        {
          label: "普通用户",
          id: 1,
        },
      ],
      organizationList: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "武汉",
          id: 0,
        },
        {
          label: "上海",
          id: 1,
        },
      ],
      tableData: [],
    };
  },

  computed: {},
  created() {
    this.init();
  },
  mounted() { },
  methods: {
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getsysLogList();
    },
    // 获取时间
    getDateTime(val) {
      if (val) {
        this.begDate = val[0];
        this.endDate = val[1];
      } else {
        this.begDate = "";
        this.endDate = "";
      }
      // this.serchKey();
    },
    init() {
      this.getsysLogList(); //列表信息
    },
    //查询系统日志列表
    getsysLogList() {
      this.$api.system
        .getsysLogList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.formInline.parentId, //上级机构（无上级为0）
          this.formInline.endTime, //结束时间
          this.formInline.startTime, //开始时间
          this.formInline.type, //类型（0操作日志，1定时任务）
          this.formInline.name //操作员id
        )
        .then((res) => {
          if (res.code == 200) {
            this.total = res.count;
            this.tableData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 查询
    systemLog() {
      if (this.formInline.updateTime != "") {
        this.formInline.endTime = this.formInline.updateTime[1];
        this.formInline.startTime = this.formInline.updateTime[0];
        this.getsysLogList();
      } else {
        this.getsysLogList();
      }
    },
    //重置
    resetSystemLog() {
      this.formInline.endTime = "";
      this.formInline.startTime = "";
      this.formInline.name = "";
      this.formInline.type = "";
      this.formInline.updateTime = "";
      this.getsysLogList();
    },
    //删除按钮
    del() {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          this.$api.designManagement
            .delfun(`/proMaterial/del/${id}`, id)
            .then((res) => {
              if (res.code == 200) {
                this.initList();
                this.$message({
                  type: "success",
                  message: res.msg,
                });
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
  },
};
</script>
<style >
@import "../../style/systemLog.scss";

.table_content1 {
  /* width: 101%; */
}
</style>